import React from "react";
import { } from "prop-types";

const propTypes = {};

const SearchError = ({ text, id }) => {
    return (
        <div className="search__app container container--p-0-m">
            <div className="search__no-results">{text}</div>
        </div>);
};

SearchError.propTypes = propTypes;
export default SearchError;
